import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'unconformity-item',
	templateUrl: './unconformity-item.component.html',
	styleUrls: ['./unconformity-item.component.css']
})
export class UnconformityItemComponent implements OnInit {
	@Input() unconformity
	constructor() {
	}

	ngOnInit() {

	}

	getColor(criticality) {
		switch (criticality) {
			case 1:
				return 'yellow'
			case 2:
				return 'red'
			case 3:
				return 'black'
			default:
				return 'blue'
		}
	}


}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/unconformity-item/unconformity-item.component.ts